import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const links = [
  { href: "#servicios", label: "Servicios" },
  { href: "#cita", label: "Cita" },
];

export default function Header() {
  const handleClick = (e, href) => {
    if (!href.startsWith("#")) return;
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  return (
    <motion.header
      data-testid="header-nav"
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 left-0 right-0 z-50 glass border-b border-[color:var(--border-subtle)]"
    >
      <div className="max-w-[1400px] mx-auto flex items-center justify-between px-6 md:px-10 h-16">
        <a href="#top" onClick={(e) => handleClick(e, "#top")} data-testid="header-logo" className="font-heading text-2xl tracking-tight leading-none">
          Dentainhoa<span className="text-[color:var(--accent)]">.</span>
        </a>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => handleClick(e, l.href)}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-sm tracking-wide text-[color:var(--text-secondary)] hover:text-[color:var(--text-primary)] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <Link to="/admin/login" data-testid="header-admin-link" className="hidden md:inline text-xs uppercase tracking-[0.2em] text-[color:var(--text-secondary)] hover:text-[color:var(--text-primary)]">
            Admin
          </Link>
          <a
            href="#cita"
            onClick={(e) => handleClick(e, "#cita")}
            data-testid="header-cta-reservar"
            className="inline-flex items-center gap-2 rounded-full bg-[color:var(--text-primary)] text-[color:var(--bg-primary)] px-5 py-2.5 text-sm hover:bg-[color:var(--signature-dark)] transition-colors"
          >
            Reservar cita
          </a>
        </div>
      </div>
    </motion.header>
  );
}
